import Icon from "tds/icon";

export { Icon };

customElements.define("tds-icon", Icon.CustomElementConstructor);
